// extracted by mini-css-extract-plugin
module.exports = {"wrap":"DealDetailsBO_wrap__91K_U","card":"DealDetailsBO_card__121Ku"};